export default __webpack_public_path__ + "static/media/zoom.2dc9eb50.svg";